import React from 'react';
import loadable from '@loadable/component';
import { SEARCH_PATH } from './Search.route.path';

const Search = loadable(() => import('./SearchContainer'));

export const SearchRoute = () => ({
  path: SEARCH_PATH,
  indexRoute: {
    component: props => <Search {...props} />,
  },
  childRoutes: [{ path: '*', component: props => <Search {...props} /> }],
});
